import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GalleryLive} from '../../../gallery/GalleryLive';
import {MultipartyDashboardController} from '../../../../MultipartyDashboardController';
import {InteractionSummaryCollapsible} from './InteractionSummaryCollapsible';
import {getRootStore} from '../../../../../../app.bootstrap';

import './RightBar.scss';

type RightBarProps = {
    vjEnabled?: boolean;
    controller: MultipartyDashboardController;
};

@observer
class RightBarComponent extends TechseeBaseComponent<RightBarProps> {
    renderInternal() {
        const {vjEnabled, controller} = this.props;
        const {localizationService} = getRootStore();

        return (
            <div className='live-dashboard-right-area'>
                <GalleryLive />

                {vjEnabled && (
                    <InteractionSummaryCollapsible
                        controller={controller}
                        translate={localizationService.translate}
                        dateFormat='MMMM D, YYYY h:mm A'
                    />
                )}
            </div>
        );
    }
}

export const RightBar = RightBarComponent;
